import api from '@edu-fe/api'

const module = {
  name: 'activity',
  getInfo: api.create(`/course/gifts`, {
    baseURL: 'https://edu-wx-wps.iciba.com'
  }),
  getQrcode: courseId => {
    return api.create(`/course/qrcode?courseId=${courseId}`, {
      baseURL: 'https://edu-wx-wps.iciba.com'
    })
  },
  getConversionInfo: api.create('/course/buy/transform')
}

export default module
